/**
 * Donation success confirmation.
 */
import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";

export default function PublicChurchDonateSuccess() {
  const { slug } = useParams();
  useEffect(() => { /* could poll session for receipt id */ }, []);
  return (
    <div data-testid="public-donate-success" className="max-w-xl mx-auto px-6 py-20 text-center text-white">
      <CheckCircle2 size={48} className="mx-auto text-emerald-400" />
      <h1 className="font-serif-display text-4xl mt-5">Thank you for your gift</h1>
      <p className="text-neutral-300 mt-3 text-sm">A receipt will reach your inbox shortly. Your generosity makes ministry possible.</p>
      <Link to={`/churches/${slug}`} className="btn-gold mt-8 inline-flex px-5 py-2.5 rounded text-xs tracking-widest uppercase font-semibold items-center gap-2">
        Back to {slug} <ArrowRight size={14} />
      </Link>
    </div>
  );
}
